module.exports = __webpack_public_path__ + "img/11.825d4dd1.svg";